import React, { useEffect, useState } from 'react'
import L, { LatLngExpression } from 'leaflet'
import { MapContainer, TileLayer, Popup, ZoomControl } from 'react-leaflet'
import { Marker as MarkerLeaflet } from 'react-leaflet'
//@ts-ignore
import mapStyles from './styles.json'
//@ts-ignore
import Icon from './map-icon.png'
import { Development, Property, RealEstateDataPageComponentData } from 'types'
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
  StandaloneSearchBox,
} from '@react-google-maps/api'

const containerStyle = {
  width: '400px',
  height: '400px',
}

const defaultMapOptions = {
  styles: mapStyles,
}

function changeFormat(value: string) {
  var convert = value.toString()
  return convert.replace(',', '.')
}

interface Props {
  data: Property | Development
  coordenadas: {
    geo_lat: number
    geo_long: number
  }
  zoom: number
  isMarkerShown: Boolean
}

const myIcon = L.icon({
  iconUrl: Icon,
  iconSize: [27, 41],
  iconAnchor: [12.5, 41],
  popupAnchor: [0, -41],
  shadowSize: [41, 41],
  shadowAnchor: [12.5, 41],
})

const getMap = (props: Props & RealEstateDataPageComponentData) => {
  const {
    data,
    coordenadas: { geo_lat, geo_long },
    zoom,
    global_data,
  } = props

  const GOOGLE_KEY = global_data.pageConfig.keys.map

  const position: LatLngExpression = [
    parseFloat(changeFormat(geo_lat.toString())),
    parseFloat(changeFormat(geo_long.toString())),
  ]

  // const center:{lat:number,lng:number} = {
  //   lat: -3.745,
  //   lng: -38.523
  // };

  const center: { lat: number; lng: number } = {
    lat: parseFloat(props.coordenadas.geo_lat.toString()),
    lng: parseFloat(props.coordenadas.geo_long.toString()),
  }

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (isMounted) {
    return props.coordenadas.geo_lat && props.coordenadas.geo_long ? (
      !GOOGLE_KEY ? (
        <div className="map map-leaflet a">
          <MapContainer
            scrollWheelZoom={false}
            zoomControl={false}
            center={position}
            dragging={!L.Browser.mobile}
            zoom={zoom || 15}
            style={{ height: '100%' }}
          >
            <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
            {/* <TileLayer url="https://api.maptiler.com/maps/dataviz/256/{z}/{x}/{y}.png?key=fzW9HzAb6C93tDpePOno" /> */}
            <ZoomControl position="bottomright" /> {/* Agregamos nuestro propio control de zoom */}
            <MarkerLeaflet
              icon={myIcon}
              position={position}
            >
              <Popup>{data?.address + ', ' + data?.location.name}</Popup>
            </MarkerLeaflet>
          </MapContainer>
        </div>
      ) : (
        <LoadScript
          googleMapsApiKey={GOOGLE_KEY ?? ''}
          libraries={['places']}
          language="es-AR"
        >
          <GoogleMap
            options={{
              draggableCursor: 'pointer',
              styles: [
                {
                  stylers: [
                    {
                      saturation: -100,
                    },
                  ],
                },
              ],
            }}
            mapContainerStyle={{
              width: '100%',
              height: '65vh',
            }}
            center={center}
            zoom={parseInt(zoom.toString(), 10)}
          >
            <Marker
              key={'marker-prop'}
              position={center}
            />
          </GoogleMap>
        </LoadScript>
      )
    ) : (
      ''
    )
  } else {
    return <></>
  }
}

export default getMap
